<template>
  <h2 class="text-base font-bold leading-6" data-test="TH2">
    <slot />
  </h2>
</template>
